<span [class.warning]="hasWarning"></span>
